import { Star, Quote } from "lucide-react";

const reviews = [
  {
    quote: "Melhor café de Alfenas, pedimos um café especial jacu, feito na hora e servido em taça de vinho - achei interessante e diferente.",
    author: "João Otávio Dázio",
    role: "Local Guide",
  },
  {
    quote: "Atendimento cordial, cafés selecionados, Pão de queijo com queijo da canastra sensacional. O melhor lugar de Alfenas.",
    author: "Tatiane Avila",
    role: "Avaliação Google",
  },
  {
    quote: "Lugar maravilhoso, atendimento perfeito. Variedades e qualidade. Amamos tudo, cafés, cachaças, gin, licor, doces...",
    author: "Vanessa Cristina",
    role: "Avaliação Google",
  },
  {
    quote: "Com certeza a melhor loja de cafés e produtos relacionados da região. Tem um ótimo atendimento e produtos de muita qualidade.",
    author: "Matheus Novaes",
    role: "Avaliação Google",
  },
  {
    quote: "Café muito saboroso, principalmente se for coado. Docinho de leite maravilhoso e preço bem acessível. Atendimento bom.",
    author: "Juliana Helena",
    role: "Local Guide",
  },
  {
    quote: "Ambiente acolhedor e produtos de altíssima qualidade. O queijo canastra é o melhor que já comi em Alfenas. Recomendo!",
    author: "Iago Silva",
    role: "Avaliação Google",
  },
  {
    quote: "Ótimo para comprar presentes mineiros legítimos. As geleias e a aguardente de café são sucessos garantidos.",
    author: "Mariana Costa",
    role: "Avaliação Google",
  },
];

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="relative bg-espresso text-cream py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(50%_40%_at_20%_80%,rgba(196,137,61,0.15),transparent_60%)]" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-14 md:mb-20">
          <div className="md:col-span-8 reveal-left">
            <div className="eyebrow text-gold mb-5 reveal-eyebrow">Prova social</div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-[80px] leading-[1.02] tracking-[-0.02em] max-w-[22ch] reveal-clip">
              Quem passa, <em className="italic text-gold">volta.</em>
            </h2>
          </div>
          <div className="md:col-span-4 reveal-right">
            <div className="flex items-center gap-3 text-cream/85">
              <div className="flex gap-0.5 text-gold">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <div className="font-display text-3xl text-cream">4.8</div>
              <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-cream/60">
                118 avaliações no Google
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Marquee */}
      <div className="relative mt-10">
        <div className="flex marquee-track-slow">
          {[...reviews, ...reviews].map((r, i) => (
            <div key={i} className="px-3 md:px-4 shrink-0">
              <blockquote
                data-testid={`review-card-${i}`}
                className="w-[300px] md:w-[380px] h-full relative rounded-[14px] p-8 md:p-10 glass hover:border-gold/40 transition-colors duration-500 flex flex-col justify-between"
              >
                <div>
                  <Quote className="text-gold mb-6" size={24} strokeWidth={1.5} />
                  <p className="font-display text-xl md:text-2xl leading-[1.4] tracking-[-0.01em] text-cream">
                    “{r.quote}”
                  </p>
                </div>
                <footer className="mt-8 pt-6 border-t border-cream/10 flex items-center justify-between">
                  <div>
                    <div className="font-body text-sm text-cream">{r.author}</div>
                    <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-cream/55 mt-1">
                      {r.role}
                    </div>
                  </div>
                  <div className="flex gap-0.5 text-gold">
                    {[...Array(5)].map((_, j) => (
                      <Star key={j} size={12} fill="currentColor" strokeWidth={0} />
                    ))}
                  </div>
                </footer>
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
